<template>
  <wrapper-preview-category>
    <p class="mb-2 ml-4">Фильтры: </p>
    <v-row dens class="form-sort">
      <input
        type="search"
        class="cms-panel-search__input input-sort"
        v-model="searchOrg"
        placeholder="Поиск по выбранному типу"
      />
      <div class="second-sort">
        <v-col class=" d-flex align-start status px-0 py-0">
          <v-select
            label="Тип поиска"
            :items="searchFields"
            v-model="selectedSearchField"
            class="cms-panel-search__sort search-type mr-5"
          />
        </v-col>
        <v-col class="status-sort">
          <v-autocomplete multiple label="Статусы заявок" v-model="currentStatus" :items="statusArr"></v-autocomplete>
        </v-col>
        <v-col cols="3" class="dates pt-6">

          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-combobox
                class="dates-sort"
                v-model="dates"
                multiple
                chips
                dense
                label="Выбрать даты"
                small-chips
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-combobox>
            </template>
            <v-date-picker
              v-model="dates"
              multiple
              locale="ru"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-autocomplete label="Сортировка" class="org-sort" v-model="currentSort" :items="sort"></v-autocomplete>
        <v-autocomplete label="Сортировка" v-model="currentSortDir" :items="sortDir"
                        class=" heigh-sort mx-3"></v-autocomplete>
        <v-btn class="blue__v-btn" @click="sortData">Сортировать</v-btn>
      </div>
    </v-row>
    <v-progress-linear indeterminate color="#00599b" v-if=" loading"></v-progress-linear>
    <div v-else-if="!appeals.length && !resultSearch.data.length" class="text-center">
      нет данных
    </div>
    <Alert alertType="primary" v-else-if="appeals.length && !resultSearch.data.length ">
      <template v-slot:icon>
        <v-icon :size="30" color="#084298">mdi-information-outline</v-icon>
      </template>
      <template v-slot:default>Поиск не дал результатов</template>
    </Alert>
    <div v-else>
      <CardAppeal
        v-for="(appeal) of resultSearch.data"
        :key="appeal.id + appeal.org.id"
        :item="appeal"
        @openAboutAppeal="onOpenAboutAppeal($event)"
      />
      <div class="mt-3 d-flex flex-row justify-center align-center">
        <v-autocomplete
          class="pagination-table"
          v-model="userPages"
          :items="pagesPaginate"
          solo
          dense
          filled
          height="все"
          :length="pagesVuetify"
          rounded
          style="max-width: 150px"
          @change="changePage($event)"
        ></v-autocomplete>
        <v-pagination
          v-model="page"
          :length="pagesVuetify"
          :total-visible="7"
          @input="changePage($event)"
        >
        </v-pagination>
      </div>
    </div>
    <v-dialog v-model="modalOpen">
      <v-card>
        <v-card-text class="pt-3">
          <template v-if="activeAppeal">
            <div class="appeal__header">
              <h2>Организация: {{ activeAppeal.org.name }}</h2>
              <h2>Показатель: {{ activeAppeal.indicator }}</h2>
              <h2>КЦП: {{ activeAppeal.kcpGroup.code + ' ' + activeAppeal.kcpGroup.name }}</h2>
              <h2>ФО: {{ activeAppeal.fo.name }}</h2>
              <h2>Усл: {{ activeAppeal.usl.name }}</h2>
              <h2>Показатель: {{ activeAppeal.indicator }}</h2>
              <h2 class="mb-2 font-weight-bold">Статус: {{ status.text }}</h2>
              <p class="d-flex align-center mb-1  appeal__span">Описание: {{ activeAppeal.decision }}</p>
              <div class="appeal__container-flex">
                <v-btn
                  class=" blue__v-btn ml-2"
                  :loading="loadingFile"
                  @click="getFile(activeAppeal.fileId)"
                >{{ activeAppeal.fileId ? activeAppeal.fileId : 'файл не приложен' }}
                </v-btn>
              </div>
              <div class="my-4"/>
              <div class="appeal__property">
                Основание отказ:
                <div>
                  <textarea v-model="appealText" class="appeal__input" rows="4"></textarea>
                </div>
                Описание отказа предыдущее:
                <p class="d-flex align-center mb-1  appeal__span">{{ activeAppeal.appeal }}</p>
              </div>
            </div>
            <v-btn class="error__v-btn" :loading="appealChangingStatus" @click="changeAppealStatus(false)">
              Отказать
            </v-btn>
            <v-btn class="blue__v-btn ml-3" :loading="appealChangingStatus" @click="changeAppealStatus(true)">
              Принять
            </v-btn>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </wrapper-preview-category>
</template>

<script>
// import moment from 'moment'
import {mapActions,} from 'vuex';
import {getAppealsAdmin, sendAppealAdmin} from "@/api/indicators";
import {sortArr} from "@/utils/helpers";
import request from "@/services/request";
import {saveFile} from '@/utils/saveFile';
import utils from "@/utils/utils";

import Alert from "@/components/cards/Alert";
import CardAppeal from "@/components/cards/indicatiors/cardAppeal";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import {tablePagination} from "@/mixins/tablePagination";

export default {
  name: "ViewIndicatorsAppeals",
  components: {
    Alert,
    WrapperPreviewCategory,
    CardAppeal
  },
  mixins: [headerTooltipFunctions, tablePagination],
  data() {
    return {
      appeals: [],
      serverData: [],
      appealText: '',
      activeAppeal: null,
      activeAppealFile: '',
      searchOrg: '',
      searchFields: ['ID', 'Организация', 'UUID'],
      selectedSearchField: 'ID',
      menu: false,
      appealChangingStatus: false,
      dates: [],
      sort: [
        {text: 'id организации', value: 'orgId', type: 'number'},
        {text: 'наименование организации', value: 'id', type: 'string'},
        {text: 'date create', value: 'date', type: 'date'},
        {text: 'status', value: 'accept', type: 'boolean'},
        // {text: 'id', value: 'id'},
      ],
      sortDir: [
        {text: 'По убыванию', value: 'asc'},
        {text: 'По возрастанию', value: 'desc'},
      ],
      statusArr: [
        // {text: 'Все заявки', value: 1},
        {text: 'На рассмотрении', value: null},
        {text: 'Удовлетворена', value: true},
        {text: 'Отказано', value: false},
      ],
      results: 0,
      loading: false,
      loadingFile: false,
      currentStatus: [true, false, null],
      currentSort: 'id',
      currentSortDir: 'desc',
      paginatorParams: {'selectedPage': 1, 'itemsPerPage': 10},
      modalOpen: false,
    }
  },
  computed: {
    // ...mapGetters('auth', {get_replace_id_admin: 'get_replace_id_admin'}),

    // dateCreate() {
    //   return moment(this.activeAppeal.createDate).format('LLL');
    // },
    // dateEdit() {
    //   return moment(this.activeAppeal.changeDate).format('LLL');
    // },

    // file() {
    //   return this.activeAppeal?.fileId ?? null
    // },
    selectedField() {
      switch (this.selectedSearchField) {
        case "ID":
          return 'id';
        case 'Организация':
          return 'name';
        case 'UUID':
          return 'uuid';
        default:
          return 'name';
      }
    },

    resultSearch() {
      let results;
      let array = this.serverData.filter((item) => {
        // if (this.currentStatus === 1) return item;
        if (this.currentStatus.includes(item.accept))
          return item;
      });
      let search = this.searchOrg;
      if (!search && this.dates.length === 0) {
        results = array.length;
        array = utils.divideArrayInPages(array, this.paginatorParams.selectedPage, this.paginatorParams.itemsPerPage)
        return {'data': array, 'counter': results};
      }
      let filterFn = null;
      search = search.trim().toLowerCase();
      switch (this.selectedField) {
        case "id":
          filterFn = (item) => {
            if (String(item.org.id).toLowerCase().indexOf(search) !== -1) {
              return item;
            }
          };
          break;
        case 'name':
          filterFn = (item) => {
            if (String(item.org[this.selectedField]).toLowerCase().indexOf(search) !== -1) {
              return item;
            }
          };
          break;
        case 'uuid':
          filterFn = (item) => {
            if (item.data.find(el => el.id === search)) {
              return item;
            }
          };
          break;
        default:
          filterFn = (item) => {
            if (String(item.org[this.selectedField]).toLowerCase().indexOf(search) !== -1) {
              return item;
            }
          };
          break;
      }
      if (this.dates.length > 0) {
        filterFn = (item) => {
          if (item?.date && (this.dates.includes(item.date.slice(0, 10)))) {
            return item;
          }
        };
      }
      array = array.filter((item) => {
        const res = filterFn(item);
        if (res) return res
      })

      results = array.length;
      array = utils.divideArrayInPages(array, this.paginatorParams.selectedPage, this.paginatorParams.itemsPerPage)
      return {'data': array, 'counter': results};
    },

    status() {
      if (this.activeAppeal.accept === null)
        return {
          text: 'На рассмотрении',
          style: 'appeal_not-set'
        }
      else if (this.activeAppeal.accept === true)
        return {
          text: 'Удовлетворена',
          style: 'appeal_accepted'
        }
      else if (this.activeAppeal.accept === false) {
        return {
          text: 'Отказано',
          style: 'appeal_rejected'
        }
      } else {
        return {
          text: 'На рассмотрении',
          style: 'appeal_rejected'
        }
      }
    },
  },
  mounted() {
    this.getAllAppeals();
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    prevPage() {
      if (this.paginatorParams.selectedPage > 1) this.paginatorParams.selectedPage -= 1
    },
    calcUgsnInfoCode(kcp) {
      if (!kcp)
        return;
      return kcp.code;
    },
    calcUgsnInfo(kcp) {
      if (!kcp)
        return;
      return kcp.code + ' ' + kcp.name;
    },
    nextPage() {
      if ((this.paginatorParams.selectedPage * this.paginatorParams.itemsPerPage) < this.resultSearch.length) this.paginatorParams.selectedPage += 1
    },
    async changeAppealStatus(flag) {
      try {
        this.appealChangingStatus = true;
        if (flag === false && this.appealText) {
          console.log('changeAppealStatus false', this.activeAppeal);
          const res = await sendAppealAdmin({
            id: this.activeAppeal.id, ...this.activeAppeal,
            accept: flag,
            appeal: this.appealText
          });
          this.activeAppeal = res;
          const ind = this.serverData.findIndex(el => el.id === res.id);
          this.serverData.splice(ind, 1, res);
          this.appealChangingStatus = false;
        } else if (flag === true) {
          console.log('changeAppealStatus true', this.activeAppeal);
          const res = await sendAppealAdmin({
            id: this.activeAppeal.id, ...this.activeAppeal,
            accept: flag,
            appeal: this.appealText
          });
          this.activeAppeal = res;
          const ind = this.serverData.findIndex(el => el.id === res.id);
          this.serverData.splice(ind, 1, res);
          this.appealChangingStatus = false;
        } else
          await this.addNotification({
            notificationStatus: 'error',
            notificationMessage: 'Заполните поле причины отказа',
            timeout: 5000
          })
        this.appealChangingStatus = false;
      } catch (e) {
        this.appealChangingStatus = false;
      }
    },
    async getAllAppeals() {
      try {
        this.loading = true;
        this.serverData = await getAppealsAdmin();

        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error('getAllAppeals', e)
      }
    },

    onOpenAboutAppeal(event) {
      this.modalOpen = true;
      this.activeAppeal = event;
    },
    sortData() {
      const item = this.sort.find(el => el.value === this.currentSort)
      this.serverData = sortArr(this.serverData, this.currentSort, this.currentSortDir, item.type);
    },
    checkForUndefined(item) {
      if (item.kcp === undefined || item.text === undefined) {
        return "Данные отсутствуют"
      } else {
        return item.kcp + ': ' + item.text
      }
    },

    async getFile(id) {
      try {
        this.loadingFile = true;
        const response = await request({
          endpoint: `/api/file/download?file=${id}`,
          method: 'GET',
        });
        saveFile({...response.data, fileBytes: response.data.file}, false);
        this.loadingFile = false;
      } catch (e) {
        this.loadingFile = false;
        console.error(e)
      }
    },
  }
}
</script>

<style scoped>
.form-sort {
  display: flex;
  flex-direction: column;

}

.second-sort {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.status {
  max-width: 160px;
}

.status-sort {
  max-width: 460px;
  max-height: 100px;
}

.search-type {
  max-width: 140px;
}

.input-sort {
  /*border: 1px solid grey;*/
  margin: 10px 10px 10px 30px;
  padding: 6px;
  border-radius: 3px;
  border: 1px solid black;
  width: 1710px;
}

.underline:hover {
  border-bottom: 1px solid black;
}

.underline::placeholder {
  font-size: 15px;
}

.dates {
  max-width: 150px
}

.dates-sort {
  max-width: 127px;
}

.org-sort {
  max-width: 270px;
}

.heigh-sort {
  max-width: 170px;
}

.done-row {
  background: #EBF9EB;
  border: 1px solid #8FE28E;
  color: #29A128
}

.err-row {
  background: #FDEBEB;
  border: 1px solid #F89B9B;
  color: #ED393E;
}

.row-box {
  border-radius: 4px;
  height: 40px;
}

.desc-span {
  max-width: 115px;
  white-space: nowrap;

  padding-left: 3px;
  box-sizing: border-box;
}

.span-box {
  flex-wrap: wrap;
  width: 100%;
  max-height: 100%;
}

.back-color {
  border: 1px solid rgb(0, 89, 155);
  border-radius: 4px;
}

.back-color::placeholder {
  padding: 5px;
  font-size: 15px;
}
</style>